import { FileCheck, Shield, Briefcase, Globe } from "lucide-react";

const credibilityItems = [
  {
    icon: FileCheck,
    label: "Property Due Diligence"
  },
  {
    icon: Shield,
    label: "Title Verification"
  },
  {
    icon: Briefcase,
    label: "Acquisition Advisory"
  },
  {
    icon: Globe,
    label: "Diaspora Investment Advisory"
  }
];

export const GlobalCredibilitySection = () => {
  return (
    <section 
      className="py-14 md:py-20 lg:py-24 bg-[#0A0A0B] relative overflow-hidden"
      data-testid="global-credibility-section"
    >
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent" />
      
      <div className="relative z-10 max-w-5xl mx-auto px-5 md:px-8 lg:px-12">
        {/* Header */}
        <div className="text-center mb-8 md:mb-12">
          <h2 className="font-['Playfair_Display'] text-xl md:text-2xl lg:text-3xl xl:text-4xl text-white leading-tight">
            Trusted Legal Counsel
            <span className="block text-[#D4AF37] italic mt-1">for Global Property Investors</span>
          </h2>
          <div className="w-12 md:w-16 h-px bg-[#D4AF37] mx-auto mt-5 md:mt-6" />
        </div>

        {/* Content */}
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
          <p className="text-white/60 text-sm md:text-base leading-[1.8] md:leading-[2]">
            4 ACES Attorneys provides specialised legal advisory services for investors seeking 
            secure property transactions in Nigeria. Our firm regularly advises clients across 
            Nigeria and the global diaspora, including investors based in the United Kingdom, 
            United States, Canada, and the United Arab Emirates.
          </p>
        </div>

        {/* Credibility Strip */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 lg:gap-10">
          {credibilityItems.map((item, index) => (
            <div 
              key={index} 
              className="flex flex-col items-center text-center group"
              data-testid={`global-cred-item-${index}`}
            >
              <div className="w-12 h-12 md:w-14 md:h-14 border border-[#D4AF37]/30 flex items-center justify-center mb-3 md:mb-4 group-hover:border-[#D4AF37] group-hover:bg-[#D4AF37]/10 transition-all duration-300">
                <item.icon className="w-5 h-5 md:w-6 md:h-6 text-[#D4AF37]" />
              </div>
              <span className="text-white/70 text-xs md:text-sm font-medium leading-tight">
                {item.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
